export default "__VITE_ASSET__Dz2ol3oh__"